import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledBubbleExplanation = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;

  .bubble-container {
    width: 100%;
    padding: 10px;
    background-color: white;
    border-radius: 20px;
    margin-top: 10px;
    margin-bottom: 10px;

    .bubble {
      height: 100%;
      width: 100%;

      > * {
        position: relative;
      }
    }
  }
  .explanation {
    padding: 5px;
    text-align: center;
  }
`;
